module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch01_hd",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "ash1"
  }, [_c('h1', {
    staticClass: "h1ch",
    attrs: {
      "id": "ch01_hd"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 16",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "r1"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("Augmentative and Alternative Communication")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Augmentative and Alternative Communication (AAC) is an area of clinical practice that is used by individuals who lack the capacity for verbal speech. Speech-language pathologists like Ms. Hunger work with many types of assistive devices—recordable buttons being one example—to help a nonverbal person communicate their thoughts and have their wants and needs met.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Since all animals except some birds lack the ability to speak, AAC is a great solution for them to be able to use language to communicate. Perhaps the most "), _c('span', {
    attrs: {
      "aria-label": "page 17",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("fascinating aspect of Ms. Hunger’s discovery is that it wasn’t made sooner. We have long known that dogs have the ability to understand language in the form of basic commands, such as “sit,” “stay,” “come,” and “heel,” and even more complex sentences. The fact that she was able to extrapolate that they might have the capacity to “talk back” is both genius and obvious. Nevertheless, kudos to her for discovering this because it’s given so many of us a fun, new hobby and a window into our learners’ personalities that we didn’t previously have.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev04"
    }
  }, [_vm._v("A Little History of “Talking” Animals")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("You might have heard of a border collie named Chaser who knew the name of all 1,022 of her toys. Her owner, Dr. John Pilley, was a professor of psychology who would no doubt be thrilled if he were alive to see what all these “talking” animals are doing today. While Chaser didn’t actively initiate communication, her capacity for vocabulary comprehension was remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 18",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("In 2018, Neil deGrasse Tyson interviewed Dr. Pilley and Chaser for an episode of "), _c('i', [_vm._v("NOVA")]), _vm._v(" on PBS. Dr. Tyson tested Chaser’s ability to retrieve a random sampling of nine toys from a pile he had picked out from her larger, one thousand plus pile. She got all nine correct. He then added a new toy to her collection. It was a plush toy of Charles Darwin. When asked to get “Darwin”—a toy name she had never "), _c('i', [_vm._v("heard")]), _vm._v(" before—Chaser was able to deduce that Darwin was the toy she had never "), _c('i', [_vm._v("seen")]), _vm._v(" before. She took a little longer to retrieve it than the toys she already knew, but once she figured it out, she quickly retrieved it from the pile and brought it to him."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/ch01#footnote-003",
      "id": "footnote-003-backlink"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another extraordinary example of a “talking” animal was Koko the Gorilla, who was a resident of the San Francisco Zoo from 1971 until her death in 2018. She had a working vocabulary of about one thousand words as well. Koko was able to use American Sign Language to initiate communication. In using the AAC buttons, learners such as Stella are essentially doing the same thing. What’s fascinating about the research being done at UCSD is that many “Chasers” and “Kokos” "), _c('span', {
    attrs: {
      "aria-label": "page 19",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("are being observed, so this study is unusual in size and scope.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the flip side of this phenomenon, it’s worth mentioning something called the “Clever Hans effect.” Clever Hans was a German horse that was famous for being able to perform arithmetic and other tasks in the early 1900s. However, a psychologist named Oskar Pfungst investigated and realized that the horse wasn’t actually doing any of the tasks, but rather watching his trainer for a reaction. In other words, Clever Hans was responding to the involuntary cues and body language of his trainer who was, of course, unaware that he was providing any of these cues.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because there is still much research to be done on animal AAC, it’s unclear how much a teacher’s subconscious cues could be influencing the communication of their learner. Studying all of these new AAC learners will be the life’s work of many animal behaviorists, cognitive scientists, and others in related fields. It’s worth being intentionally neutral as your learner begins to use the buttons to avoid any possibility of triggering the Clever Hans effect.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev05"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 20",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Talking Animal Pioneers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("To say that the talking animal movement has taken off is an understatement! Do a search of any of the following hashtags on either Instagram or TikTok and you will find tons of enjoyable content related to the animal AAC world:")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxta"
  }, [_vm._v("#TheyCanTalk")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxt"
  }, [_vm._v("#TalkingDog")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxt"
  }, [_vm._v("#FluentPet")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxt"
  }, [_vm._v("#ButtonTraining")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxt"
  }, [_vm._v("#MyDogTalks")]), _vm._v(" "), _c('p', {
    staticClass: "noindtxt"
  }, [_vm._v("#Hunger4Words (named after Ms. Hunger’s blog)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a community, there has been some concern that using the #AAC hashtag for animals might prevent people searching for AAC resources for humans from finding relevant content. But #AnimalAAC, #DogAAC, #CanineAAC, #CatAAC, or #FelineAAC would probably work. Hashtags are a moving target, so keep exploring to see what pulls up the most relevant content for you. YouTube also has a lot of tutorials, so definitely "), _c('span', {
    attrs: {
      "aria-label": "page 21",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("subscribe to channels that seem most applicable to your learner and situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you are first starting out, it is super helpful to find some learners who are similar to yours, whether they’re the same species or breed. They can be virtual mentors—just like Stella and Ms. Hunger were for us.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev06"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Please note that teaching your animal to communicate using AAC isn’t for everyone. We’ve all done just fine having animal companions who understand simple verbal commands and communicate back to us in a nonverbal way. My family’s dog growing up had different pitches of barking to let us know what he needed. He also understood basic obedience commands. I’d venture to say we understood each other 99.9 percent of the time. So, if you try this and for whatever reason it doesn’t work out, don’t despair. Our pets will still find a way to let us know what’s up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Embarking on this journey requires a commitment to the process in addition to the end goal. Some dogs "), _c('span', {
    attrs: {
      "aria-label": "page 22",
      "id": "page_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and animals will pick this up very quickly while others may be scared, try to play with or destroy the buttons, or simply show zero interest at first. Some learners have caught on in six days and others have taken six months. There isn’t really a way to know how long it will take for your learner to grasp the concept.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before we knew about the buttons, we had trained Casper to use a call bell near his bowl to signal that he was hungry, and potty bells that hung on the front door for him to signal us he needed to go outside. That made transitioning to buttons easier because he was already using these two different bells as AAC devices. However, it initially took some time for him to learn to use the bells when we first introduced them. With that in mind, consider that some learners might take a while to master their first button. That’s why above all else, the key to teaching your dog to talk is "), _c('i', [_vm._v("patience")]), _vm._v(". To use a popular saying, “It’s a marathon, not a sprint.” Even if your goal is to teach your learner a limited number of words (ten or fewer), you’ll want to go slowly and follow some guidelines that seem to work for a large number of successful talking animals (see Chapters 3 and 4 for the guidelines I’ve provided in this book).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 23",
      "id": "page_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("As you read this guide, also allow yourself to get creative with your learner. Just because something worked for "), _c('i', [_vm._v("one")]), _vm._v(" dog (or cat or horse), doesn’t mean it will work for your learner. Sure, we are all following some basic guidelines, but every learner is different, so meet them where they are and find that path of least resistance. By that I mean, be willing to change things on the fly if they don’t seem to be working. Even though I’m writing this guide and will try to cover as much ground as possible, there is no way to go into detail for every scenario you might encounter. That’s why the collaborative online groups are so helpful. Make sure you join some of them, which I will cover in the Resources chapter ("), _c('span', {
    attrs: {
      "href": "#/e9781646042760/xhtml/ch07#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 118")]), _vm._v(") so you can share any cool tips and tricks with other AAC enthusiasts. We’re all learning as we go, and our collective knowledge is so valuable to this movement.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s even a research group that is a collaboration between CleverPet (maker of the FluentPet products that I’ll cover on "), _c('span', {
    attrs: {
      "href": "#/e9781646042760/xhtml/ch02#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 27")]), _vm._v(") and the University of California San Diego. You can enroll by going to this link: "), _c('a', {
    attrs: {
      "href": "https://survey.zohopublic.com/zs/t4BU6s",
      "target": "_blank"
    }
  }, [_vm._v("https://survey.zohopublic.com/zs/t4BU6s")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, let’s get talking!")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/ch01#footnote-003-backlink",
      "id": "footnote-003"
    }
  }, [_vm._v("3")]), _vm._v(" NOVA PBS Official, “Chaser the Dog Shows Off Her Smarts to Neil deGrasse Tyson,” August 20, 2018, "), _c('a', {
    attrs: {
      "href": "https://youtu.be/omaHv5sxiFI",
      "target": "_blank"
    }
  }, [_vm._v("https://youtu.be/omaHv5sxiFI")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5653c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042760/xhtml/ch01.vue
// module id = 69
// module chunks = 0